import HelpCenterList from 'containers/helpCenter/HelpCenterList';
import { USER_ROLE } from '../../utils/constants';
import ContactInquiryList from './InquiryList';
import CONTACT_INQUIRY_LINKS from './links';
import HelpCenter from 'containers/helpCenter/HelpCenter';
import ConsultationsList from 'containers/consultation';
import ConsultationConversation from 'containers/consultation/ConsultationConversation';
import ConsultationDetails from 'containers/consultation/details';

export default [
  {
    path: CONTACT_INQUIRY_LINKS.CONTACT_INQUIRY_LISTING,
    exact: true,
    component: ContactInquiryList,
    role: [USER_ROLE.ADMIN],
  },

  // HELP_CENTER
  {
    path: CONTACT_INQUIRY_LINKS.HELP_CENTER,
    exact: true,
    component: HelpCenterList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: CONTACT_INQUIRY_LINKS.HELP_CENTER_CONVERSATIONS,
    exact: true,
    component: HelpCenter,
    role: [USER_ROLE.ADMIN],
  },

  // CONSULTATIONS_LIST
  {
    path: CONTACT_INQUIRY_LINKS.CONSULTATIONS_LIST,
    exact: true,
    component: ConsultationsList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: CONTACT_INQUIRY_LINKS.CONSULTATIONS_CONVERSATIONS,
    exact: true,
    component: ConsultationConversation,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: CONTACT_INQUIRY_LINKS.CONSULTATION_DETAILS,
    exact: true,
    component: ConsultationDetails,
    role: [USER_ROLE.ADMIN],
  },
];
